import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, StatusBadge, Loading, Tag } from "@/components/common";
import { Stack, Plug } from "@phosphor-icons/react";
import { toast } from "sonner";

const LABEL_COLOR = { CLOUD: "#00E5FF", PREMIUM: "#FF007F", "STUDIO LOCAL": "#00FF9D" };

export default function Providers() {
  const { data: providers, loading } = useFetch("/providers");
  if (loading || !providers) return <Loading />;

  const cats = [...new Set(providers.map((p) => p.category))];

  return (
    <div>
      <PageHeader icon={Stack} title="AI Provider Manager"
        subtitle="The studio is never locked to one AI company. Configure providers per category. Architecture lets you swap providers later without rebuilding the studio." />

      <div className="space-y-4">
        {cats.map((cat) => (
          <div key={cat}>
            <div className="text-xs uppercase tracking-wider text-zinc-500 mb-2">{cat}</div>
            {providers.filter((p) => p.category === cat).map((p) => (
              <Panel key={p.id} data-testid={`provider-${p.id}`} className="flex items-center gap-4 mb-2">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-white">{p.name}</span>
                    <span className="font-mono text-[10px] font-bold px-1.5 py-0.5 rounded border" style={{ color: LABEL_COLOR[p.label], borderColor: `${LABEL_COLOR[p.label]}55` }}>{p.label}</span>
                  </div>
                  <div className="text-xs text-zinc-500">{p.note}</div>
                </div>
                <button onClick={() => toast(p.status === "LIVE" ? "Already live via Universal Key." : "Phase 2: connect this provider.")}
                  className="inline-flex items-center gap-1.5 rounded-full bg-white/5 border border-white/10 px-3 py-1.5 text-xs text-white hover:border-white/30 transition-colors"><Plug size={13} weight="duotone" /> Configure</button>
                <StatusBadge status={p.status} />
              </Panel>
            ))}
          </div>
        ))}
      </div>
      <p className="mt-6 text-xs text-zinc-500">Statuses: <StatusBadge status="LIVE" /> real · <StatusBadge status="TEST" /> sandbox · <StatusBadge status="NOT CONNECTED" /> · <StatusBadge status="ERROR" /></p>
    </div>
  );
}
